import { Map, fromJS } from 'immutable';
import { CLEAR, ERROR, INITIALIZE, START, SUCCESS } from './constants';

export const initialAsyncStatus = Map({
	cancellationSource: null,
	error: null,
	isRequesting: false,
	isComplete: false,
});

export const initialState = Map();

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case CLEAR: {
			let newState = state;
			action.keyPaths.forEach(keyPath => {
				newState = newState.removeIn(keyPath);
			});

			return newState;
		}
		case ERROR:
			return state.mergeIn(
				action.keyPath,
				fromJS({
					isRequesting: false,
					error: action.error,
				}),
			);
		case INITIALIZE:
			return state.setIn(action.keyPath, initialAsyncStatus);
		case START:
			return state.mergeIn(
				action.keyPath,
				initialAsyncStatus.merge(
					fromJS({
						isRequesting: true,
						cancellationSource: action.cancellationSource,
					}),
				),
			);
		case SUCCESS:
			return state.mergeIn(
				action.keyPath,
				fromJS({
					isRequesting: false,
					isComplete: true,
				}),
			);
		default:
			return state;
	}
};

export default reducer;
